import { Outlet, useNavigate } from "react-router-dom";
import * as React from "react";
import { CommandPalette, NavBar, SideBar } from "./";
import { useSelector } from "react-redux";

const Layout = ({ currentPage }) => {
  const navigate = useNavigate();
  const state = useSelector((state) => state.UserReducer);

  const [openCommandPalette, setOpenCommandPalette] = React.useState(false);
  const [moduleNames, setModuleNames] = React.useState([
    {
      name: "Dashboard",
      description: "Summarized view of work happening",
      url: "/",
    },
    {
      name: "AddressBook",
      description: "Complete list of Customer Records",
      url: "/addressbook",
    },
    {
      name: "AddressBook > Create",
      description: "New Customer to the records",
      url: "/addressbook/create",
    },
    {
      name: "Enquiry",
      description: "List of all enquiries",
      url: "/enquiry",
    },
    {
      name: "Enquiry > Create",
      description: "New Enquiry to the system",
      url: "/enquiry/create",
    },
    {
      name: "Task",
      description: "Tasks tagged to each Services",
      url: "/servicetask",
    },
    {
      name: "Task > Create",
      description: "Create new Service Task",
      url: "/servicetask/create",
    },
    {
      name: "Service",
      description: "Service tickets created from Enquiries",
      url: "/serviceticket",
    },
    {
      name: "Settings",
      description: "Control options listed in input forms",
      url: "/admin/form-input-settings",
    },
    {
      name: "Manage User Accounts",
      description: "Control user accounts and edit their access levels",
      url: "/user/manage-user-accounts",
    },
    {
      name: "User Account > Create",
      description: "Create user account",
      url: "/user/manage-user-accounts/create",
    },
  ]);

  const onChangeCommandPalette = (selectedObject) => {
    navigate(JSON.parse(selectedObject).url, { replace: false });
  };

  const [open, setOpen] = React.useState(false);

  return (
    <main className='App'>
      <CommandPalette
        openPalette={openCommandPalette}
        moduleNames={moduleNames}
        onChangeCommandPalette={onChangeCommandPalette}
      />
      {state.user && (
        <header className='sticky top-0 z-60 shadow'>
          <NavBar />
        </header>
      )}
      {state.user ? (
        <div className='flex'>
          <SideBar open={open} setOpen={setOpen} />
          <div
            className='flex-1 z-30'
            onClick={(e) => {
              setOpen(false);
            }}>
            <Outlet />
          </div>
        </div>
      ) : (
        <Outlet />
      )}
    </main>
  );
};

export default Layout;
